import { render, staticRenderFns } from "./SplashHeader.vue?vue&type=template&id=afa0ad50&scoped=true&"
import script from "./SplashHeader.vue?vue&type=script&lang=js&"
export * from "./SplashHeader.vue?vue&type=script&lang=js&"
import style0 from "./SplashHeader.vue?vue&type=style&index=0&id=afa0ad50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa0ad50",
  null
  
)

export default component.exports